import React, { useContext, useState } from 'react';
import { Popover } from 'antd';

import { SaveOutlined } from '@ant-design/icons';

import { StyledButton } from '../../components/Button';
import { CandidateDuplicatesContext } from '../../components/CandidateDuplicatesContext';
import { DetailsHeaderButton } from '../../components/DetailsHeaderActions';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';

type SaveNewCandidateButtonProps = {
  disabled?: boolean;
  onSave: () => void;
};

export const SaveNewCandidateButton: React.FC<SaveNewCandidateButtonProps> = ({ disabled, onSave }) => {
  const [showPopover, setShowPopover] = useState(false);
  const { isCandidateDuplicated } = useContext(CandidateDuplicatesContext);

  const clickWhenPopoverOpenedHandler = () => {
    if (showPopover) {
      setShowPopover(false);
      window.removeEventListener('click', clickWhenPopoverOpenedHandler);
    }
  };

  const handleSave = () => {
    if (isCandidateDuplicated) {
      setShowPopover(true);
    } else {
      onSave();
    }
  };

  const handleCancel = () => {
    setShowPopover(false);
  };
  const Title: React.FC = () => {
    return (
      <StyledRow gap="0.5rem" justifyContent="flex-start">
        <div>Confirmation</div>
      </StyledRow>
    );
  };

  const PopoverContent: React.FC = () => (
    <StyledColumn width="400px">
      <StyledColumn gap="0">
        <div style={{ color: '#f6bd03' }}>Warning!</div>
        <div style={{ color: '#f6bd03' }}>
          Candidates with the same first and last name already existin the database.
        </div>
      </StyledColumn>
      <StyledColumn gap="0">
        <div>Please verify your input.</div>
        <div>Confirm only if you are sure it is correct.</div>
      </StyledColumn>
      <div>Do you confirm saving the form?</div>
      <StyledRow justifyContent="flex-end" marginTop="10px">
        <StyledButton type="default" onClick={onSave}>
          Confirm
        </StyledButton>
        <StyledButton type="primary" onClick={handleCancel}>
          Cancel
        </StyledButton>
      </StyledRow>
    </StyledColumn>
  );

  return (
    <Popover
      placement="bottomRight"
      title={<Title />}
      content={<PopoverContent />}
      open={showPopover && isCandidateDuplicated}
      trigger="click"
      afterOpenChange={() => window.addEventListener('click', clickWhenPopoverOpenedHandler)}
    >
      <DetailsHeaderButton
        type="primary"
        onClick={handleSave}
        icon={<SaveOutlined aria-hidden />}
        disabled={disabled || showPopover}
      >
        Save
      </DetailsHeaderButton>
    </Popover>
  );
};
